import createVueComponent from '../createVueComponent';

const CircleDot = createVueComponent('CircleDotIcon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['circle', { cx: '12', cy: '12', r: '1', key: '41hilf' }],
]);

export default CircleDot;
